import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@environment';
import { AgreementAdditionOrder } from '@model';

@Injectable()
export class AgreementsService {
 

  constructor(private http: HttpClient) {}

  createAdditionAgreement(order: AgreementAdditionOrder){
    return this.http
      .post<number>(`${environment.apiEndpoint}/agreements/addition`, order)
      .pipe(catchError(error => throwError(() => new Error(error.json()))));
  }

  getAgreementLink(agreementId: number): Observable<string>{
      return this.http
          .get<any>(`${environment.apiEndpoint}/agreements/${agreementId}/link`)
          .pipe(
            map(accessLink => accessLink.link),
            catchError(error => throwError(() => new Error(error.json())))
          );
  }

  getIsAdditionAgreementCreated(payload: AgreementAdditionOrder) {
    return this.http
    .post<boolean>(`${environment.apiEndpoint}/agreements/isadditioncreated`, payload)
    .pipe(catchError(error => throwError(() => new Error(error.json()))));
}
}

